/**
 * Configuration PUBLIQUE du serveur de jeu.
 *
 * Ce que le serveur veut bien dire de lui-meme, et rien de plus : un lien
 * d'invitation Discord et deux drapeaux. Les URL de webhook ne sortent JAMAIS
 * du serveur, et c'est la raison d'etre de ce fichier : sans lui, la tentation
 * serait de poser la vraie URL dans une variable `VITE_`, donc dans le bundle,
 * donc en clair dans le navigateur de tout le monde.
 *
 * Charge UNE FOIS, au demarrage, et jamais attendu : tant que la reponse n'est
 * pas la, les boutons concernes n'existent pas. Un serveur muet donne donc
 * exactement le meme resultat qu'un serveur sans Discord, ce qui est le
 * comportement voulu.
 */
import { useSyncExternalStore } from 'react';
import { serverHttpBase } from './net/connection.js';

export interface PublicConfig {
  /** Lien d'invitation du serveur Discord, ou null s'il n'y en a pas. */
  readonly discordInvite: string | null;
  /** Le partage d'une retouche vers Discord est-il configure ? */
  readonly shareToDiscord: boolean;
}

const EMPTY: PublicConfig = { discordInvite: null, shareToDiscord: false };

let current: PublicConfig = EMPTY;
let started = false;
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  // Le premier abonne declenche la requete : un module importe mais jamais
  // affiche ne doit rien couter.
  if (!started) {
    started = true;
    void load();
  }
  return () => listeners.delete(listener);
}

async function load(): Promise<void> {
  try {
    const response = await fetch(`${serverHttpBase()}/config`);
    if (!response.ok) return;
    const body = (await response.json()) as Partial<PublicConfig>;
    current = {
      discordInvite: typeof body.discordInvite === 'string' ? body.discordInvite : null,
      shareToDiscord: body.shareToDiscord === true,
    };
    for (const listener of listeners) listener();
  } catch {
    // Serveur injoignable : on reste sur EMPTY. Les boutons ne s'affichent pas,
    // ce qui vaut mieux qu'un bouton qui ne menerait nulle part.
  }
}

export function usePublicConfig(): PublicConfig {
  return useSyncExternalStore(subscribe, () => current, () => EMPTY);
}
